export class Quotes {

    constructor() {
        this.showOneQuote()
    }

    showOneQuote() {
        let $container = $('[data-show-quote]');
        let quotes = $container.find('.block-quote').length;
        let randomQuoteNumber = Math.floor(Math.random() * quotes) +1;

        // first hide all quotes
        $container.find('.block-quote').hide();

        // show random quote
        $container.find('.block-quote:nth-child(' + randomQuoteNumber + ')').show();
    }
}



// WEBPACK FOOTER //
// ./src/Frontend/Themes/Custom/src/Js/Theme/Quotes.js